import { fill, t } from '../strings';
import { RECORD_ROUTES } from '../pages/recordPages';

/**
 * 🔒 The 06:00 recheck of a dispatched visit's crew (piece 29; decision 4340).
 * Booking a crew is the dispatch, so a worker is checked once at the booking;
 * on the visit's day the job `recheckVisitCrews` re-runs the site gate, the
 * sub-skill check and the certification check for every worker on each
 * Dispatched visit starting that day. Each worker found short raises one
 * `VisitCrewLapsed` To-Do on the person who booked the visit. 🔨 It never
 * holds the visit or the job.
 */
export const RECHECK_VISIT_CREWS_JOB = 'recheckVisitCrews';
export const CREW_RECHECK_HOUR_KEY = 'workorder.crewRecheckHour';
export const CREW_RECHECK_DEFAULT_HOUR = 6;

/** The To-Do's kind, and the record it is raised on: the visit itself. */
export const VISIT_CREW_LAPSED_KIND = 'VisitCrewLapsed' as const;
export const VISIT_CREW_SOURCE = 'WorkOrderVisit';

/** What the title and the detail name: the worker, the visit's label and its job's number. */
export interface CrewLapseNames {
  worker: string;
  visit: string;
  job: string;
}

/**
 * 🔨 The To-Do's title names the worker, the visit and the job, and nothing
 * that changes through the day. It is how a run finds the item it raised for
 * that worker on that visit, so one stands per visit and worker per day.
 */
export function crewLapseTitle(names: CrewLapseNames): string {
  return fill(t('work.crewRecheck.todo'), { worker: names.worker, visit: names.visit, job: names.job });
}

/** The detail names what lapsed, each in the words the booking's warnings use. */
export function crewLapseDetail(names: CrewLapseNames, lapses: readonly string[]): string {
  return fill(t('work.crewRecheck.todoDetail'), { worker: names.worker, visit: names.visit, job: names.job, lapses: lapses.join('; ') });
}

/** 🔒 The To-Do row opens the visit's page, through the Service Report's route, which finds a visit by its id alone. */
export function crewLapseRoute(visitId: string): string {
  return RECORD_ROUTES.ServiceReport.record.replace(':id', encodeURIComponent(visitId));
}
